import React from "react";

import { Typography } from "@mui/material";

const PopupTitle = ({ children }: { children: React.ReactNode }) => {
  return (
    <Typography variant="h2" sx={{ color: "shades.neutral.800", mb: 1 }}>
      {children}
    </Typography>
  );
};

export default PopupTitle;
